import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { tipMsg } from './utils/tipTools'
import AES from '@/utils/aes'

// 引入測試用的roles
// import roles from './testRoles'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'registerResult', 'gittoken'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  // alert(JSON.stringify(to))
  // 检查拿到的Token是否过期
  if (to.query.lang) {
    store.dispatch('SetLang', to.query.lang)
  }
  // 若地址栏有提供token，则将其保存到cookie中
  if (to.query.token && to.name !== 'Robot and Designer Purchase') {
    // alert(to.query.token)
    Vue.prototype.$token.savetoken({ access_token: to.query.token })
    Vue.prototype.$cookies.set('access_token', AES.Encrypt(to.query.token))
  }
  const token = Vue.prototype.$token.loadToken().access_token || ''
  // alert('获取的Token：' + token)
  if (token && token !== 'null') {
    /* has token */
    // alert(token)
    // 检查token过期的地址
    const checkTokenUrl = `${Vue.prototype.$config.checkToken_url}?token=${token}`
    //  获取用户信息的地址
    const getUserInfoUrl = `${Vue.prototype.$config.userInfoUri}?token=${token}`
    // token可用时，获取用户信息
    // store.dispatch('getUserInfo', getUserInfoUrl)
    // 检查token是否已过期
    store.dispatch('checkToken', checkTokenUrl).then(res => {
      // alert(JSON.stringify(res))
      // alert(res.data.status)
      // console.log(res, 'checkToken')

      /** code
       * 4005 token不合法
       */
      if (res.data.code === 4005) {
        // 清空token
        Vue.prototype.$token.deleteToken()
        // 将登录状态设为未登录
        store.commit('updateLoginStatus', false)
        // 提示并回到token获取页重新获取token
        // alert(localStorage.getItem('lang'))
        //  国际化提示语句
        tipMsg('warning', `${window.$globalHub.$t('authorizationTip')}`)
        // alert('提示到期')
        setTimeout(() => {
          next({ path: '/user/login' })
        }, 500)
        // next({ path: '/user/login', query: { redirect: to.fullPath } })
      } else {
        // debugger
        store.dispatch('getUserInfo', getUserInfoUrl).then(userInfo => {
          // 拿到用户信息后，再进行下一步走向
          if (userInfo.tenantNo) {
            store.dispatch('junpNovice').then(() => {
              next()
              NProgress.done()
            })
          }
        })
      }
    })
  } else {
    // 清空未正常退出的情况下，保存的用户信息
    store.commit('updateUserInfo', '')
    // 将登录状态设为未登录
    store.commit('updateLoginStatus', false)
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login' })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles
    const permissionId = vnode.context.$route.meta.permission
    let actions = []
    roles.permissions.forEach(p => {
      if (p.permissionId !== permissionId) {
        return
      }
      actions = p.actionList
    })
    if (actions.indexOf(actionName) < 0) {
      setTimeout(() => {
        if (el.parentNode == null) {
          el.style.display = 'none'
        } else {
          el.parentNode.removeChild(el)
        }
      }, 10)
    }
  }
})

export {
  action
}
